import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const portfolios = [
  {
    name: "Frontend Development",
    image: "/p/web.jpg",
    description: "View my web projects.",
    url: "/p/web",
  },
  {
    name: "UI/UX Design",
    image: "/p/sites/arg-2.jpg",
    description: "View my UI designs.",
    url: "/p/ui",
  },
  {
    name: "Game Development",
    image: "/blog/i/ragdoll.jpg",
    description: "Gameplay programming work.",
    url: "/p/gameplay",
  },
  {
    name: "3D Design",
    image: "/p/cvl.jpg",
    description: "My work as a 3D artist.",
    url: "/p/3d",
  },
];

export default function Portfolios() {
  return (
    <Box
      sx={{
        display: "grid",
        gap: 3,
        px: 2,
        py: 6,
        justifyContent: "center",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(4, 1fr)",
        },
        maxWidth: 1280,
        margin: "0 auto",
      }}
    >
      {portfolios.map((portfolio) => (
        <Card
          key={portfolio.name}
          component={RouterLink}
          to={portfolio.url}
          sx={{
            maxWidth: 320,
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            textDecoration: "none",
            color: "inherit",
            transition: "transform 0.2s ease-in-out",
            "&:hover": {
              transform: "scale(1.02)",
            },
          }}
        >
          <Box sx={{ position: "relative", height: 160 }}>
            <CardMedia
              component="img"
              image={portfolio.image}
              alt={portfolio.name}
              sx={{ height: "100%", width: "100%", objectFit: "cover" }}
            />
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background:
                  "radial-gradient(circle, rgba(0,0,0,0) 40%, rgba(0,0,0,0.3) 100%)",
                pointerEvents: "none",
              }}
            />
          </Box>

          <CardContent sx={{ flexGrow: 1 }}>
            <Typography variant="h6" gutterBottom>
              {portfolio.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {portfolio.description}
            </Typography>
          </CardContent>
          <Box sx={{ px: 2, pb: 2 }}>
            <Button
              variant="outlined"
              fullWidth
              component="div" // prevents nested RouterLink issues
            >
              View
            </Button>
          </Box>
        </Card>
      ))}
    </Box>
  );
}
